import config from "../common/config";
let left = (window.screen.width/2)-(600/2)
let top = (window.screen.height/2)-(400/2)
// import common from './common';
function shareLeagueOnFacebook(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans, type) {
    e.stopPropagation();
    let description, caption = "";
    // description = "UAE fantasy game {{name}} {{code}}";
    description = trans["fb_league_share_description"] ? trans["fb_league_share_description"] : "";
    description = description.replace('{{code}}', LeagueCode);
    let picture = config.IMG_BASE + "global-icon.svg?v=" + config.WebConfig.imgVersion
    // description = description.replace('{{name}}', LeagueName);
    // caption = "fantasy"
    
    caption = trans["fb_league_share_caption"] ? trans["fb_league_share_caption"] : "";
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(ShareLoad) + "&quote=" + description, caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);

}
function shareLeagueOnTwitter(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans, type) {
    e.stopPropagation();
    let description, caption = "";
    // description = "UAE fantasy game {{name}} {{code}}";
    description = trans["tw_league_share_description"] ? trans["tw_league_share_description"] : "";
    description = description.replace('{{code}}', LeagueCode);
    // description = description.replace('{{name}}', LeagueName);
    // caption = "fantasy";
    caption = trans["tw_league_share_caption"] ? trans["tw_league_share_caption"] : "";
    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(ShareLoad) + '&text=' + encodeURIComponent(description);
    window.open(url, caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);
}

function shareLeagueOnWhatsapp(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans, type) {
    e.stopPropagation();
    let description, caption = "";
    // description = "UAE fantasy game {{name}} {{code}}";
    description = trans["whatsapp_league_share_description"] ? trans["whatsapp_league_share_description"] : "";
    description = description.replace('{{code}}', LeagueCode);
    // description = description.replace('{{name}}', LeagueName);
    // caption = "fnatsy";
    caption = trans["whatsapp_league_share_caption"] ? trans["whatsapp_league_share_caption"] : "";
    const url = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(description)+" "+encodeURIComponent(ShareLoad);
    window.open(url, caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);
}

function shareDreamTeamOnFacebook(e, DreamTeamUrl, trans) {
    e.stopPropagation();
    // common.customTracking('Share Dream Team');
    /*const URL = config.BASE_URL + '/' + config.APP_NAME + '/leagues/' + DreamTeamUrl;*/
    const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(DreamTeamUrl) + "&quote=" + fb_dreamteam_share_description, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);
    /*window.FB.ui({
        method : 'feed',
        link   : URL,
        display: 'popup',
        caption: fb_dreamteam_share_caption,
        quote  : fb_dreamteam_share_description
    }, function (response) {
    });*/
}
function shareTeamOfTheSeasonOnFacebook(e, DreamTeamUrl, trans) {
    e.stopPropagation();
    // common.customTracking('Share Dream Team');
    /*const URL = config.BASE_URL + '/' + config.APP_NAME + '/leagues/' + DreamTeamUrl;*/
    const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(DreamTeamUrl) + "&quote=" + fb_dreamteam_share_description, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);
    /*window.FB.ui({
        method : 'feed',
        link   : URL,
        display: 'popup',
        caption: fb_dreamteam_share_caption,
        quote  : fb_dreamteam_share_description
    }, function (response) {
    });*/
}
function shareDreamTeamOnTwitter(e, DreamTeamUrl, trans) {
    e.stopPropagation();
    // common.customTracking('Share Dream Team');
    const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;
    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(DreamTeamUrl) + '&text=' + encodeURIComponent(fb_dreamteam_share_description);
    window.open(url, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);
}
function shareTeamOfTheSeasonOnTwitter(e, DreamTeamUrl, trans) {
    e.stopPropagation();
    // common.customTracking('Share Dream Team');
    const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;
    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(DreamTeamUrl) + '&text=' + encodeURIComponent(fb_dreamteam_share_description);
    window.open(url, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);
}
function shareTeamOnFacebook(e,gameday, imgUrl, trans, type) {
    e.stopPropagation();
    let description, caption = "";
    description = trans["fb_team_share_description"] ? trans["fb_team_share_description"] : "";
    
    caption = trans["fb_team_share_caption"] ? trans["fb_team_share_caption"] : "";
    caption = caption.replace('{{matchDay}}', gameday);
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(imgUrl) + "&quote=" + encodeURIComponent(description), caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);

}
function shareTeamOnTwitter(e,gameday, imgUrl, trans, type) {
    e.stopPropagation();
    let description, caption = "";
    description = trans["tw_team_share_description"] ? trans["tw_team_share_description"] : "";   
    caption = trans["tw_team_share_caption"] ? trans["tw_team_share_caption"] : "";
    caption = caption.replace('{{matchDay}}', gameday);

    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(imgUrl) + '&text=' + encodeURIComponent(description);
    window.open(url, caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);

}
function shareTeamOnWhatsapp(e,gameday, imgUrl, trans, type) {
    e.stopPropagation();
    let description, caption = "";
    description = trans["whatsapp_team_share_description"] ? trans["whatsapp_team_share_description"] : "";
       
    caption = trans["whatsapp_team_share_caption"] ? trans["whatsapp_team_share_caption"] : "";
    caption = caption.replace('{{matchDay}}', gameday);

    const url = 'https://api.whatsapp.com/send?' + encodeURIComponent(imgUrl) + '&text=' + encodeURIComponent(description);
    window.open(url, caption, 'width=600,height=400, scrollbars=no, resizable=no, top='+top+', left='+left, false);

}
export { shareLeagueOnFacebook, shareLeagueOnTwitter, shareLeagueOnWhatsapp, shareDreamTeamOnFacebook, shareDreamTeamOnTwitter, shareTeamOfTheSeasonOnFacebook, shareTeamOfTheSeasonOnTwitter,shareTeamOnFacebook,shareTeamOnTwitter,shareTeamOnWhatsapp };